import React from "react"
import { CollapsableContainer } from "@ciq/shared/components/collapsable"
import { Slider } from "@ciq/shared/components/slider"
import { useFilterQueryParams } from "../../hooks/filter_query_params"

/**
 * Returns a human-readable label for the given flow threshold value.
 *
 * @param {number} threshold - Threshold percentile (0-95)
 * @returns {string} Label like "All traffic" or "Top 25%"
 */
function getThresholdLabel(threshold) {
  if (threshold === 0) return "All traffic"
  return `Top ${100 - threshold}%`
}

/**
 * Campus Flow module for the left panel.
 * Non-collapsible section with a toggle to enable/disable campus flow visualization
 * and a threshold slider to filter flow routes by percentile.
 *
 * @returns {React.ReactElement} Campus flow module component
 */
export function CampusFlowModule() {
  const { campusFlow, flowThreshold, setFilters } = useFilterQueryParams()

  const handleToggle = (checked) => {
    setFilters({ campusFlow: checked })
  }

  const handleThresholdChange = (e) => {
    setFilters({ flowThreshold: parseInt(e.target.value, 10) })
  }

  const header = (
    <div className="campus-flow-module__header">
      <span>Campus Flow</span>
      <Slider checked={campusFlow} onChecked={handleToggle} />
    </div>
  )

  return (
    <CollapsableContainer collapsible={false} header={header}>
      {campusFlow && (
        <div className="campus-flow-module__controls">
          <div className="campus-flow-module__threshold">
            <span className="campus-flow-module__label">Threshold</span>
            <span className="campus-flow-module__value">{getThresholdLabel(flowThreshold)}</span>
          </div>
          <input
            className="campus-flow-module__slider"
            type="range"
            min={0}
            max={95}
            step={5}
            value={flowThreshold}
            onChange={handleThresholdChange}
          />
          <div className="campus-flow-module__slider-labels">
            <span>All</span>
            <span>Top 5%</span>
          </div>
        </div>
      )}
    </CollapsableContainer>
  )
}
